import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class MerchantProfilesService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/merchant_profiles", { params: toSnakeCase(params) });
  }
}

export default new MerchantProfilesService();
